"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScript = exports.loadScript = void 0;
/**
 * Load GTM script tag.
 *
 * @param id GTM ID.
 * @param config The config object.
 * @returns The script element.
 */
function loadScript(id, config) {
  var _a, _b, _c, _d, _e;
  const doc = document;
  const script = doc.createElement('script');
  const scriptLoadListener = event => {
    var _a;
    (_a = config.onReady) === null || _a === void 0 ? void 0 : _a.call(config, {
      id,
      script
    });
    script.removeEventListener('load', scriptLoadListener);
  };
  script.addEventListener('load', scriptLoadListener);
  window.dataLayer = (_a = window.dataLayer) !== null && _a !== void 0 ? _a : [];
  (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime()
  });
  if (!id) {
    return script;
  }
  script.async = !config.defer;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  script.defer = Boolean(config.defer || config.compatibility);
  if (config.nonce) {
    script.nonce = config.nonce;
  }
  const queryString = new URLSearchParams(_objectSpread({
    id
  }, (_c = config.queryParams) !== null && _c !== void 0 ? _c : {}));
  const source = (_d = config.source) !== null && _d !== void 0 ? _d : 'https://www.googletagmanager.com/gtm.js';
  script.src = `${source}?${queryString}`;
  const parentElement = (_e = config.parentElement) !== null && _e !== void 0 ? _e : doc.body;
  if (typeof (parentElement === null || parentElement === void 0 ? void 0 : parentElement.appendChild) !== 'function') {
    throw new Error('parentElement must be a DOM element');
  }
  parentElement.appendChild(script);
  return script;
}
exports.loadScript = loadScript;
/**
 * Check if GTM script is in the document.
 *
 * @param source The URL of the script, if it differs from the default. Default: 'https://www.googletagmanager.com/gtm.js'.
 * @returns `true` if in the `document` is a `script` with `src` containing `'https://www.googletagmanager.com/gtm.js'` (or `source` if specified), otherwise `false`.
 */
function hasScript() {
  let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://www.googletagmanager.com/gtm.js';
  return Array.from(document.getElementsByTagName('script')).some(script => script.src.includes(source));
}
exports.hasScript = hasScript;